import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { PartnerVotesProvider } from './contexts/PartnerVotesContext';
import { Partners } from './pages/Partners';
import { PartnerProfile } from './pages/PartnerProfile';
import { ThemeProvider } from 'next-themes';
import { SiteSchema } from './components/SiteSchema';
import { ScrollManager } from './components/ScrollManager';
import { DgptHeader } from './components/dgpt/DgptHeader';
import { DgptFooter } from './components/dgpt/DgptFooter';
import { Home } from './pages/Home';
import { SampleMemo } from './pages/SampleMemo';
import { About } from './pages/About';
import { ToolsDirectory } from './pages/ToolsDirectory';
import { ToolPage } from './pages/ToolPage';
import { NotFound } from './pages/NotFound';
import { Agents } from './pages/Agents';
import { Solutions } from './pages/Solutions';
import { VentureCapital } from './pages/VentureCapital';
import { Enterprise } from './pages/Enterprise';
import { Security } from './pages/Security';
import { Pricing } from './pages/Pricing';
import { SolutionPage } from './pages/SolutionPage';
import { Mcp } from './pages/Mcp';
type AppProps = {
  /**
   * Design preview only: show sample usage counts (labelled "Illustrative count")
   * on tools without a verified count. Must stay false in production.
   */
  showIllustrativeCounts?: boolean;
  /**
   * Design preview only: simulate the MCP waitlist outcome without sending anything.
   * "live" submits to the real endpoint. Must stay "live" in production.
   */
  mcpWaitlistPreview?: 'live' | 'success' | 'already_registered' | 'error';
};
export function App({
  showIllustrativeCounts = false,
  mcpWaitlistPreview = 'live'
}: AppProps) {
  return <ThemeProvider attribute="class" defaultTheme="light" enableSystem data-id="element-0" data-mp="3dlntedv8gvx8">
      <BrowserRouter data-id="element-1" data-mp="nw2ci75e7srm">
        <ScrollManager data-id="element-2" data-mp="nuhj4kutefvc" />
        <SiteSchema data-id="element-3" data-mp="nvas7sh8xhgn" />
        {/* Top padding reserves space for the fixed header (h-16 / lg:h-[72px]). */}
        <div className="min-h-screen w-full bg-ink pt-16 font-sans text-text-primary antialiased lg:pt-[72px]" data-id="element-4" data-mp="swqcvjfihlyi">
          <DgptHeader data-id="element-5" data-mp="38b6kw4i7udz" />
          <Routes data-id="element-6" data-mp="3udavo55x0h34">
            <Route path="/" element={<Home data-id="element-8" data-mp="3uc9nq9k74apm" />} data-id="element-7" data-mp="3ubrgkhvzwc2x" />
            <Route path="/agents" element={<Agents data-id="element-10" data-mp="d57f31uekgij" />} data-id="element-9" data-mp="3uf5hrmsxaf8s" />
            <Route path="/solutions" element={<Solutions data-id="element-12" data-mp="d2l7x3bfc30u" />} data-id="element-11" data-mp="d3cujon1mqez" />
            <Route path="/solutions/:slug" element={<SolutionPage data-id="element-14" data-mp="86w4uq0743zs" />} data-id="element-13" data-mp="85ujnspgu14c" />
            <Route path="/mcp" element={<Mcp waitlistPreview={mcpWaitlistPreview} data-id="element-16" data-mp="3gl4qfe4avuig" />} data-id="element-15" data-mp="83i6dsunkexm" />
            <Route path="/venture-capital" element={<VentureCapital data-id="element-18" data-mp="3bmjrrj4p5iw4" />} data-id="element-17" data-mp="3glnz048296jt" />
            <Route path="/enterprise" element={<Enterprise data-id="element-20" data-mp="3bk72ekwm0691" />} data-id="element-19" data-mp="3bnmgbkejr98v" />
            <Route path="/security" element={<Security data-id="element-22" data-mp="3qbzg6sgr9c8n" />} data-id="element-21" data-mp="3qaxulu2457co" />
            <Route path="/pricing" element={<Pricing data-id="element-24" data-mp="3lkr6rwffdqvh" />} data-id="element-23" data-mp="3qdaj6q2dmfyp" />
            <Route path="/sample-memo" element={<SampleMemo data-id="element-26" data-mp="3lj6bu5p785x3" />} data-id="element-25" data-mp="3ljg2lvi2ih3u" />
            <Route path="/about" element={<About data-id="element-28" data-mp="2xu3ja2t10snt" />} data-id="element-27" data-mp="2xuwt5cna7ya6" />
            <Route path="/tools" element={<ToolsDirectory data-id="element-30" data-mp="2xsk289zjqdkz" />} data-id="element-29" data-mp="2xtby7lx22dbs" />
            <Route path="/tools/:slug" element={<ToolPage showIllustrativeCounts={showIllustrativeCounts} data-id="element-32" data-mp="2svafj23jkg0u" />} data-id="element-31" data-mp="2swbpt4cqgyhi" />
            <Route element={<PartnerVotesProvider data-id="element-34" data-mp="18bolyqu3ijz2">
                  <Outlet data-id="element-35" data-mp="1d4zpahzp8im8" />
                </PartnerVotesProvider>} data-id="element-33" data-mp="18cq7jp8qmov1">
              <Route path="/partners" element={<Partners data-id="element-37" data-mp="ygwix7hqv4ww" />} data-id="element-36" data-mp="yg3lwy8l7try" />
              <Route path="/partners/:slug" element={<PartnerProfile data-id="element-39" data-mp="13e565mhr1z50" />} data-id="element-38" data-mp="ydil8ck0zjvs" />
            </Route>
            <Route path="*" element={<NotFound data-id="element-41" data-mp="1r495virtheqq" />} data-id="element-40" data-mp="13clp3to9rk26" />
          </Routes>
          <DgptFooter data-id="element-42" data-mp="1r5kafkt36qiw" />
        </div>
      </BrowserRouter>
    </ThemeProvider>;
}